"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
var PaidCallType;
(function (PaidCallType) {
    PaidCallType["AUDIO"] = "AUDIO";
    PaidCallType["VIDEO"] = "VIDEO";
})(PaidCallType = exports.PaidCallType || (exports.PaidCallType = {}));
exports.isPaidCallTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "PaidCallTransactionDetails";
};
class PaidCallsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            TransactionDetails: () => `
        ... on PaidCallTransactionDetails {
          callId
          call {
             ${this.getFragment("Call")}
          }
          startTime
          endTime
          minutePrice
        }
      `,
        };
    }
    subscribeRequestPaymentForCall(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
          subscription {
            requestPaymentForCall
          }
        `,
        }, data => {
            onData(data.requestPaymentForCall);
        }, onError);
    }
    paidCallUpdate({ data }) {
        return this.mutate("paidCallUpdate", { data });
    }
}
exports.PaidCallsProvider = PaidCallsProvider;
//# sourceMappingURL=PaidCallsProvider.js.map